import { createRouter, createWebHistory } from "vue-router";
import PollsView from "@/views/PollsView.vue";
import CreatePollView from "@/views/CreatePollView.vue";
import LoginView from "@/views/LoginView.vue";
import Dashboard from "./src/views/DashboardView.vue";
import SpacesView from "./src/views/SpacesView.vue";
import PollResult from "./src/components/dashboard/PollResultDetails.vue";
import { isAuthenticated, getUserRoles } from "./src/services/token.js";
import TargetUsersView from "@/views/TargetUsersView.vue";
import HomeView from "@/views/HomeView.vue";
import RegistrationView from "@/views/RegistrationView.vue";
import OrganizationSettingsView from "@/views/OrganizationSettingsView.vue";

const routes = [
  { path: "/", component: HomeView },
  { path: "/register", component: RegistrationView },
  { path: "/polls", component: PollsView, meta: { requiresAuth: true } },
  {
    path: "/polls/create",
    component: CreatePollView,
    meta: { requiresAuth: true },
  },
  { path: "/login", component: LoginView },
  { path: "/dashboard", component: Dashboard, meta: { requiresAuth: true } },
  {
    path: "/dashboard/poll-result/:pollId",
    component: PollResult,
    name: "poll-result",
    meta: { requiresAuth: true },
    props: (route) => ({ pollId: route.params.pollId }),
  },
  { path: "/spaces", component: SpacesView, meta: { requiresAuth: true } },
  {
    path: "/members",
    component: TargetUsersView,
    meta: { requiresAuth: true },
  },
  {
    path: "/organization-settings",
    component: OrganizationSettingsView,
    meta: { requiresAuth: true, requiresRole: "ORGANIZATION_ADMIN" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const userRoles = getUserRoles();

  if (to.meta.requiresAuth && !isAuthenticated()) {
    next("/login");
  } else if (
    to.meta.requiresRole &&
    (!isAuthenticated() || !userRoles[0].includes(to.meta.requiresRole))
  ) {
    next("/");
  } else if (to.path === "/login" && isAuthenticated()) {
    next("/");
  } else {
    next();
  }
});

export default router;
